import React, {useEffect, useState} from "react";
import styled, {css} from "styled-components";
import {useSelector} from "react-redux";
import {
    getCentred,
    getFliped,
    getId,
    getLoaded,
    getSelectedAttributesMapped,
    getWall,
    getZoom,
} from "../../reducers/project/selectors";
import Draggable, {DraggableData} from "react-draggable";
import {Category} from "../../reducers/project";
import {useDesktop} from "../../components/Responsive";
import question from "../../assets/icons/question.png"
import Loader from "./Loader";

const Wrapper = styled.div<{
    desktop: boolean;
    wall: number;
    preview?: boolean;
    zoom: number;
}>`
  display: flex;
  align-items: center;
  transform: scale(${({ zoom }) => zoom});
  justify-content: center;
  height: ${({ desktop }) => (desktop ? "100%" : "97%")};
  background-size: ${({ desktop }) => (desktop ? "1378px 847px" : "cover")};
  overflow: hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${({ wall }) =>
    require(`../../assets/walls/wall${wall}.jpg`)});
`;

const Img = styled.img<{desktop?:boolean, fliped: boolean; jpg?: boolean; handle?: boolean }>`
  height: auto;
  width: ${({ jpg }) => (jpg ? "86" : "100")}%;
  margin-left: ${({ jpg, desktop }) => (jpg && desktop ? "7%" : "unset")};
  margin-top: ${({ jpg }) => (jpg ? "6%" : "unset")};
  transition: transform 0.3s ease-out;
  transform: scaleX(${({ fliped }) => (fliped ? -1 : 1)});
  z-index: 1000;
  
  @media (max-width:1024px) and (orientation: portrait) {
    height: 100%;
    width: calc(${({ jpg }) => (jpg ? "24" : "27")}vh - 10px);
    margin-top: ${({ jpg }) => (jpg ? "16%" : "6%")};
  }
`;

const Sizable = styled.div<{ desktop: boolean; jpg?: boolean }>`
  width: ${({ desktop }) => (desktop ? "260px" : "auto")};
  height: ${({ desktop }) => (desktop ? "auto" : "calc(56vh + 2px)")};
  position: absolute;
  overflow: hidden;
 
  
`;

const LoadingWrapper = styled.div`
    width: 100%;
    height: 100%;
    background-color: white;
    opacity: 0.6;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
`

function Visualizer({ preview, order }: IVisualizer) {
    const [pos, setPos] = useState({ x: 0, y: 0 });
    const [bouds, setBounds] = useState({left: 0, right: 0, top: 0, bottom: 0})
    const [featured, setFeatured] = useState(0);
    const desktop = useDesktop();
    const ref = React.useRef((null as unknown) as HTMLDivElement);
    const dragRef = React.useRef((null as unknown) as HTMLDivElement);
    const contenerRef = React.useRef(null as unknown as HTMLDivElement)
    const loaded = useSelector(getLoaded)
    const id = useSelector(getId)

    const featuredProject = order?.cart?.projects[featured];

    useEffect(() => {
        if (preview) {
            setInterval(() => {
                if (featured + 1 === order?.cart?.projects?.length) {
                    setFeatured(0);
                } else {
                    setFeatured(featured + 1);
                }
            }, 7000);
        }
    }, []);


    let selected = useSelector(getSelectedAttributesMapped);
    let zoom = useSelector(getZoom);
    let fliped = useSelector(getFliped);
    let centred = useSelector(getCentred);
    let wall = useSelector(getWall);

    if (preview && featuredProject) {
        selected = featuredProject.components;
        fliped = featuredProject.flipped;
        wall = featuredProject.wall;
    }

    const onDrag = (_: any, data: DraggableData) =>
    {
        setPos({ x: data.x, y: data.y });
    }

    useEffect(() => {
        const {width, height} = ref.current.getBoundingClientRect()
        const {width: cwidth, height: cheight} = contenerRef.current.getBoundingClientRect()

        const horizontal = (width-cwidth)/2
        const vertical = (height-cheight)/2

        setBounds({left: -horizontal, right: horizontal, top: -vertical, bottom: vertical})

        let {x, y} = pos

        if(pos.x > horizontal){
            x = horizontal
        }
        if(pos.x < -horizontal){
            x = -horizontal
        }

        if(pos.y > vertical){
            y = vertical
        }
        if(pos.y < -vertical){
            y = -vertical
        }

        setPos({x: x, y: y})

    }, [zoom])

    // useEffect(() => {
    //   function resize() {
    //     const {width, height} = ref.current.getBoundingClientRect()
    //     console.log(width, height, width/height)
    //   }
    //   window.addEventListener('resize', resize)
    //
    //   return () => window.removeEventListener('resize', resize)
    // }, [])

    const onDragStop = (_: any, data: DraggableData) => {
    }

    useEffect(() => {
        setPos({ x: 0, y: 0 });
    }, [centred]);

    const model = selected.filter(Boolean).find((s) => s.category === Category.Model);

    const color = selected.filter(Boolean).find(s=> s.category === Category.Color);

    return (
        <div ref={contenerRef} style={{width: desktop? preview? "100%":"60%":'100%', height: desktop? preview? '95%':"unset":'100%'}}>
            <Draggable
                scale={zoom}
                position={pos}
                onDrag={onDrag}
                onStop={onDragStop}
                defaultPosition={{ x: 0, y: 0 }}
                disabled={zoom === 1}
                bounds={bouds}
            >
                <div ref={dragRef} style={{ height: "100%", width: "100%" }}>
                    {(!loaded && id && !preview) && <LoadingWrapper>
                        <Loader/>
                    </LoadingWrapper>}
                    <Wrapper
                        zoom={zoom}
                        ref={ref}
                        desktop={desktop}
                        wall={wall}
                        draggable={false}
                        preview={preview}
                    >
                        {selected.filter(Boolean).map((s, i) => (
                            <Sizable
                                jpg={
                                    s?.category === Category.Handle && (model?.simg.includes("jpg") || model?.simg.includes("jpeg"))
                                }
                                desktop={desktop}
                                key={"key" + i}
                                style={{ zIndex: mapCategoryToZIndex(s?.category), display: (fliped && mapCategoryToZIndex(s?.category) == 90) || (selected.filter(Boolean).find(s => s.name.toLowerCase().includes('BEZPRZYLGOWE'.toLowerCase())) && mapCategoryToZIndex(s?.category) == 90 && s?.name?.toLowerCase()?.includes('zawias'))? 'none':'unset' }}
                            >
                                <div style={{ cursor: zoom !== 1 ? "grabbing" : "unset" }}>
                                    <Img
                                        desktop={desktop}
                                        fliped={fliped? !selected.filter(Boolean).find(s => s.slug === 'side_left'):selected.filter(Boolean).find(s => s.slug === 'side_left')}
                                        jpg={[Category.Model, Category.Variant, Category.Color].includes(s?.category)}
                                        draggable={false}
                                        src={mapColors(s, color)}
                                    />
                                </div>
                            </Sizable>
                        ))}
                    </Wrapper>
                </div>
            </Draggable>
        </div>
    );
}

const krata = {
    calvados: ["ORZECH PREMIUM", "DAB ŚREDNI GREKO", "ZŁOTY DĄB GREKO"],
    szary: ["KLON SZARY PREMIUM", "JESION GRAFIT PREMIUM", "BETON PREMIUM", "SZARY DĄB GREKO", "WIĄZ GREKO", "DĄB SZARY ST CPL", "SOSNA SZARA ST CPL", "POPIELATY CPL", "ANTRACYT CPL"],
    bialy: ["KORA BIAŁA PREMIUM", "SOSNA BIAŁA GREKO", "BIAŁY GREKO", "ŚNIEŻNOBIAŁY GREKO", "BIAŁY ST CPL", "BIAŁY CPL"],
    dab: ["DĄB PREMIUM", "MODRZEW POPRZECZNY", "DĄB GREKO", "SONOMA GREKO", "SANREMO GREKO", "DĄB ST CPL", "JASNA AKACJA FINISH", "AKACJA FINISH", "DĄB CPL"],
    ciemny_braz: ["ORZECH GREKO", "WENGE ST CPL", "ORZECH FINISH"]
}

const tuleje = {
    biala: ["BIAŁY PREMIUM", "BIAŁY GREKO", "ŚNIEŻNOBIAŁY GREKO", "BIAŁY ST CPL", "BIAŁY CPL"],
    dab_greko: ["DĄB GREKO", "JASNA AKACJA FINISH", "DĄB CPL"],
    dab_premium: ["DĄB PREMIUM"],
    dab_sredni: ["DAB ŚREDNI GREKO", "AKACJA FINISH"],
    dab_szary: ["SZARY DĄB GREKO", "SOSNA SZARA ST CPL"],
    dab_szary_st: ["DĄB ST CPL"],
    jesion_grafit: ["JESION GRAFIT PREMIUM", "ANTRACYT CPL"],
    klon_szary: ["KLON SZARY PREMIUM", "DĄB SZARY ST CPL"],
    kora_biala: ["KORA BIAŁA PREMIUM"],
    modrzew: ["MODRZEW POPRZECZNY"],
    orzech_greko: ["ORZECH GREKO", "ORZECH FINISH"],
    orzech_premium: ["ORZECH PREMIUM"],
    sonoma: ["SONOMA GREKO", "SANREMO GREKO"],
    sosna_biala: ["SOSNA BIAŁA GREKO"],
    szary: ["BETON PREMIUM", "POPIELATY CPL"],
    wenge: ["WENGE ST CPL"],
    wiaz_greko: ["WIĄZ GREKO"],
    zloty_dab_greko: ["ZŁOTY DĄB GREKO"],
}

const mapColors = (s, color) => {
    if(!color) return s?.vimg? process.env.REACT_APP_URL + s?.vimg:question

    if(s.name.toLowerCase().includes('krata')){
        const c = Object.entries(krata).find(([key, value]) => value.includes(color.name))
        return `/static/img/krata/${c? c[0] : 'dab'}.png`
    }

    if(s.name.toLowerCase().includes('tuleje tworzywowe')){
        const c = Object.entries(tuleje).find(([key, value]) => value.includes(color.name))
        return `/static/img/tuleja/${c? c[0] : 'biala'}.png`
    }
    return s?.vimg? process.env.REACT_APP_URL + s?.vimg:question
}

const mapCategoryToZIndex = (category: Category): number => {
    switch (category) {
        case Category.Handle:
            return 70;
        case Category.HandleColor:
            return 75;
        case Category.Signboard:
            return 80
        case Category.Adds:
            return 90;
        case Category.AddsColor:
            return 100;
        case Category.Model:
            return 10;
        case Category.Variant:
            return 20;
        case Category.Color:
            return 30;
        case Category.Jamb:
            return 50;
        case Category.JambColor:
            return 60;
        default:
            return 1;
    }
};

export interface IVisualizer {
    preview?: boolean;
    order?: any;
}

export default Visualizer;
